import React from 'react';

const Logo = ({ width = 200, height = 200, className = "" }) => {
  return (
    <img
      src="/assets/images/MintSchool Logo.png"
      alt="The MINT School Logo"
      width={width}
      height={height}
      className={className}
      style={{
        objectFit: 'contain',
        filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))'
      }}
    />
  );
};

export default Logo;
